<section class="provider-profile">
  <div class="provider-header-with-bio">
    <div class="provider-header-container">
      <div class="provider-header">
        @if (!noProfilePhoto) {
          <div class="image-container">
            <img 
              src="{{ providerShareableProfile().profile_photo_url }}" 
              alt="{{ providerShareableProfile().display_name }} licensed professional therapist in {{ locationStatesWithCertifications | stringArrayToCommaList }}"
              class="provider-image"
              fetchpriority="high"
              data-test="provider-image"
            >
          </div>
        } @else {
          <br/>
        }

        <div class="provider-header-details">
          <div class="provider-header-badge" data-test="provider-badge">
            {{ providerType }}
          </div>
          <h2 class="provider-name" data-test="provider-display-name">{{ providerShareableProfile().display_name }}</h2>
          <p class="provider-credentials" data-test="provider-credentials">
            <span class="provider-credential-abbreviations"> {{ certificationAbbreviations | stringArrayToCommaListNoConjunction }} </span>
            @if (providerShareableProfile()?.pronouns?.length > 0) {
              <span 
                class="provider-pronouns"
                data-test="provider-pronouns"
              >
                ({{ providerShareableProfile().pronouns }})
              </span>
            }
          </p>
          <div class="provider-licensed-states" data-test="provider-state">
            @for (state of locationStatesWithCertifications; track state; let last = $last) {
              <span (click)="navigateToProviderDirectory(state)" class="state-link">{{state}}</span>
              @if (!last) {
                <span>, </span>
              }
            }
          </div>
          <ng-container *ngTemplateOutlet="providerPills; context: { className: 'show-desktop' }"></ng-container>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="providerPills; context: { className: 'show-mobile' }"></ng-container>
    </div>
    @if (providerShareableProfile().mini_bio.length) {
      <div class="mini-bio-container" data-test="mini-bio-card">
        <iris-icon
          name="quote"
          colorToken="$color-dec-indigo-80"
        />
        <div class="mini-bio">
          {{ providerShareableProfile().mini_bio }} <span class="name-signoff"> – {{ providerShareableProfile().display_first_name }} </span>
        </div>
      </div>
    }
  </div>
</section>

<ng-template #providerPills let-className="className">
  <div class="type-and-insurance-container" [ngClass]="className">
    <div class="provider-pills">
      <div class="list-item">
        <div class="icon-container">
          <iris-icon
            name="shield_with_heart"
            colorToken="$color-action-base"
            [size]="iconSizes.SM"
          ></iris-icon>
        </div>

        <span class="bullet-item">
          Most clients with insurance have a <span class="copay-amount">$25 copay. </span>
          <span
            class="see-plans-button"
            (click)="scrollToElement('insurance-and-licensure-section')"
          >
            See accepted plans
          </span>
        </span>
      </div>

      <div class="list-item">
        <div class="icon-container">
          <iris-icon
            name="location_outline_light"
            colorToken="$color-action-base"
            [size]="iconSizes.SM"
          ></iris-icon>
        </div>

        <span class="bullet-item">
          <span *ngIf="offersVideo()">Video</span>
          <span *ngIf="offersInPerson() && offersVideo()"> or </span>
          <span *ngIf="offersInPerson()">In-person</span>
          sessions
        </span>
      </div>
    </div>
  </div>
</ng-template>
